import LintasGeneralAPI from './lintas-general.api'

export default LintasGeneralAPI